import React from 'react';
import HeroSection from '../../components/shared/HeroSection';
import StandardsCompliance from './sections/StandardsCompliance';
import SILAssessment from './sections/SILAssessment';
import ToolsMethods from './sections/ToolsMethods';
import Footer from '../../components/shared/Footer';

const Certifications = () => {
  return (
    <div>
      {/* Hero Section */}
      <HeroSection 
        backgroundImage="/assets/asset-7.jpg"
        title="Certifications & Standards"
      />

      {/* Standards & Compliance */}
      <StandardsCompliance />

      {/* Safety Integrity Level Assessment */}
      <SILAssessment />

      {/* Tools & Methods */}
      <ToolsMethods />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Certifications;